<kt-portlet class="knostos-grid">
  <kt-portlet-header
    [title]="'PRESCRIPTION.PRESCRIPTIONS_LIST' | translate"
    [class]="'card-head-lg'"
    [viewLoading$]="dataSource?.loading$"
  >
    <ng-container ktPortletTools>
      <div>
        <button mat-raised-button class="btn btn-light-primary" (click)="openDrpDialog()">
          View DRPs
        </button>
        <button mat-raised-button class="btn btn-primary ml-2" (click)="addPrescription()">
          <span
            inlineSVG="assets/media/svg/icons/General/add_circle_icon.svg"
            class="svg-icon svg-icon-md"
          ></span>
          <span>{{ 'PRESCRIPTION.ADD_PRESCRIPTION' | translate }}</span>
        </button>
        <button
          mat-raised-button
          matTooltip="Export as CSV"
          class="btn btn-icon btn-primary ml-2"
          (click)="exportPrescriptionsAsCSV($event)"
        >
          <i class="fas fa-download"></i>
        </button>
      </div>
    </ng-container>
  </kt-portlet-header>
  <kt-portlet-body>
    <div class="mb-5">
      <div class="search-tool">
        <button
          style="width: 150px !important"
          class="btn btn-sm btn-light-{{
            getItemCssClassByStatus(searchIsActiveSelect?.value)
          }} mr-4"
          (click)="toggleStatus($event)"
        >
          {{ getItemStatusString(searchIsActiveSelect?.value) }} Prescriptions
        </button>
        <mat-form-field appearance="standard">
          <mat-label>{{ 'TABLE.SEARCH' | translate }}</mat-label>
          <input matInput #searchInput [placeholder]="'TABLE.SEARCH' | translate" />
          <button
            *ngIf="searchInput.value"
            matSuffix
            mat-icon-button
            (click)="resetInput($event, searchInput, true)"
          >
            <mat-icon>close</mat-icon>
          </button>
          <mat-hint align="start">
            {{ 'TABLE.SEARCH' | translate }}
            <strong>{{ 'TABLE.IN_ALL_FIELDS' | translate }}</strong>
          </mat-hint>
        </mat-form-field>
        <button
          matTooltip="Search by Field/s"
          class="btn btn-sm btn-icon btn-light ml-2"
          (click)="toggleSearchBar($event)"
        >
          <span
            inlineSVG="assets/media/svg/icons/General/columns.svg"
            class="svg-icon svg-icon-md"
          ></span>
        </button>
      </div>
    </div>
    <div class="mat-table-wrapper">
      <mat-table #sort="matSort" matSort [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="drug">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PRESCRIPTION.TABLE.DRUG' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let prescription">
            <span
              matTooltip="View Prescription"
              class="clickable"
              (dblclick)="viewPrescription(prescription)"
              >{{ getDrug(prescription.drug) }}</span
            >
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchDrug">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PRESCRIPTION.TABLE.DRUG' | translate }}</mat-label>
              <input
                matInput
                #searchDrugInput
                [placeholder]="'PRESCRIPTION.TABLE.DRUG' | translate"
              />
              <button
                *ngIf="searchDrugInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchDrugInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="rx">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PRESCRIPTION.TABLE.RX' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let prescription">{{ prescription.pms_rx_number }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchRx">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PRESCRIPTION.TABLE.RX' | translate }}</mat-label>
              <input matInput #searchRxInput [placeholder]="'PRESCRIPTION.TABLE.RX' | translate" />
              <button
                *ngIf="searchRxInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchRxInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="doctor">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PRESCRIPTION.TABLE.DOCTOR' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let prescription"
            >{{ prescription.doctor?.first_name }} {{ prescription.doctor?.last_name }}</mat-cell
          >
        </ng-container>
        <ng-container matColumnDef="searchDoctor">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PRESCRIPTION.TABLE.DOCTOR' | translate }}</mat-label>
              <input
                matInput
                #searchDoctorInput
                [placeholder]="'PRESCRIPTION.TABLE.DOCTOR' | translate"
              />
              <button
                *ngIf="searchDoctorInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchDoctorInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="prescriptionDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PRESCRIPTION.TABLE.PRESCRIPTION_DATE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let prescription">{{
            prescription.prescribe_date | date : 'MM/dd/yyyy'
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchPrescriptionDate">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PRESCRIPTION.TABLE.PRESCRIPTION_DATE' | translate }}</mat-label>
              <input
                matInput
                #searchPrescriptionDateInput
                [matDatepicker]="searchPrescriptionDatePicker"
                [placeholder]="'PRESCRIPTION.TABLE.PRESCRIPTION_DATE' | translate"
              />
              <button
                *ngIf="searchPrescriptionDateInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchPrescriptionDateInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle
                *ngIf="!searchPrescriptionDateInput.value"
                matSuffix
                [for]="searchPrescriptionDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #searchPrescriptionDatePicker></mat-datepicker>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="lastFilledDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PRESCRIPTION.TABLE.LAST_FILLED_DATE' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let prescription">{{
            prescription.last_filled_date | date : 'MM/dd/yyyy'
          }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchLastFilledDate">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PRESCRIPTION.TABLE.LAST_FILLED_DATE' | translate }}</mat-label>
              <input
                matInput
                #searchLastFilledDateInput
                [matDatepicker]="searchLastFilledDatePicker"
                [placeholder]="'PRESCRIPTION.TABLE.LAST_FILLED_DATE' | translate"
              />
              <button
                *ngIf="searchLastFilledDateInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchLastFilledDateInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
              <mat-datepicker-toggle
                *ngIf="!searchLastFilledDateInput.value"
                matSuffix
                [for]="searchLastFilledDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #searchLastFilledDatePicker></mat-datepicker>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="daysSupply">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PRESCRIPTION.TABLE.DAYS_SUPPLY' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let prescription">{{ prescription.days_supply }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchDaysSupply">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PRESCRIPTION.TABLE.DAYS_SUPPLY' | translate }}</mat-label>
              <input
                matInput
                #searchDaysSupplyInput
                [placeholder]="'PRESCRIPTION.TABLE.DAYS_SUPPLY' | translate"
              />
              <button
                *ngIf="searchDaysSupplyInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchDaysSupplyInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="refill">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PRESCRIPTION.TABLE.REFILL' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let prescription">{{ prescription.refill }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchRefill">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PRESCRIPTION.TABLE.REFILL' | translate }}</mat-label>
              <input
                matInput
                #searchRefillInput
                [placeholder]="'PRESCRIPTION.TABLE.REFILL' | translate"
              />
              <button
                *ngIf="searchRefillInput.value"
                matSuffix
                mat-icon-button
                (click)="resetInput($event, searchRefillInput)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="hold">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PRESCRIPTION.TABLE.HOLD' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let prescription">
            <div style="height: 30px; width: 30px" class="d-flex flex-center">
              <span
                *ngIf="prescription.is_hold"
                matTooltip="On Hold"
                inlineSVG="assets/media/svg/icons/General/pause.svg"
                class="svg-icon svg-icon-md"
              ></span>
            </div>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchHold">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PRESCRIPTION.TABLE.HOLD' | translate }}</mat-label>
              <mat-select #searchHoldSelect [placeholder]="'PRESCRIPTION.TABLE.HOLD' | translate">
                <mat-option value="">All</mat-option>
                <mat-option value="true">On Hold</mat-option>
                <mat-option value="false">Not on Hold</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="isActive">
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'PRESCRIPTION.TABLE.STATUS' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let prescription">
            <span
              style="width: 61px"
              class="label label-lg label-light-{{
                getItemCssClassByStatus(prescription.is_active.toString())
              }} label-inline text-center"
            >
              {{ getItemStatusString(prescription.is_active.toString()) }}
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchIsActive">
          <mat-header-cell *matHeaderCellDef>
            <mat-form-field appearance="standard">
              <mat-label>{{ 'PRESCRIPTION.TABLE.STATUS' | translate }}</mat-label>
              <mat-select
                #searchIsActiveSelect
                [placeholder]="'PRESCRIPTION.TABLE.STATUS' | translate"
                (selectionChange)="handleStatusChange()"
              >
                <mat-option value="">All</mat-option>
                <mat-option value="true">Active</mat-option>
                <mat-option value="false">Inactive</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-header-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef>{{ 'TABLE.ACTIONS' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let prescription">
            <button
              matTooltip="{{ 'TABLE.VIEW' | translate }} Prescription"
              class="btn btn-icon btn-light btn-hover-success btn-sm m-1"
              (click)="viewPrescription(prescription)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/visible.svg"
                class="svg-icon svg-icon-md svg-icon-success"
              ></span>
            </button>
            <button
              matTooltip="{{ 'TABLE.UPDATE' | translate }} Prescription"
              class="btn btn-icon btn-light btn-hover-primary btn-sm m-1"
              (click)="updatePrescription(prescription)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/edit_icon.svg"
                class="svg-icon svg-icon-md svg-icon-primary"
              ></span>
            </button>
            <button
              matTooltip="{{ 'TABLE.DELETE' | translate }} Prescription"
              class="btn btn-icon btn-light btn-hover-danger btn-sm m-1"
              (click)="deletePrescription(prescription)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/delete_icon.svg"
                class="svg-icon svg-icon-md svg-icon-danger"
              ></span>
            </button>
            <button
              matTooltip="{{ 'Prescription note' | translate }}"
              class="btn btn-icon btn-light hover:bg-[#e3f6fb] btn-sm m-1"
              (click)="updateNotesPrescription(prescription)"
            >
              <span
                inlineSVG="assets/media/svg/icons/General/prescription-note.svg"
                class="svg-icon svg-icon-md svg-icon-danger"
              ></span>
            </button>
            <button
              matTooltip="{{ 'TABLE.CREATE' | translate }} DRP"
              class="btn btn-icon btn-light btn-hover-secondary btn-sm m-1"
              (click)="customDRP(prescription)"
            >
              DRP
            </button>
            <button
              class="btn btn-sm btn-light btn-hover-secondary m-1"
              matTooltip="History"
              (click)="showHistory(prescription)"
            >
              <i class="fas fa-history p-0"></i>
            </button>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="searchActions">
          <mat-header-cell *matHeaderCellDef>
            <button
              class="btn btn-sm btn-light-primary w-50 m-1"
              (click)="handleSearchByField($event)"
            >
              {{ 'TABLE.SEARCH' | translate }}
            </button>
            <button class="btn btn-sm btn-light w-50 m-1" (click)="resetSearchBar($event)">
              {{ 'GLOBAL.RESET' | translate }}
            </button>
          </mat-header-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header"></mat-header-row>
        <mat-header-row
          [hidden]="!showSearchBar"
          *matHeaderRowDef="searchBarColumns"
          class="search-cols sticky-header"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
      <div class="mat-table-message" *ngIf="!dataSource?.hasItems">
        {{ 'GLOBAL.NO_RECORDS_FOUND' | translate }}
      </div>
      <div class="mat-table-message" *ngIf="dataSource?.isPreloadTextViewed$ | async">
        {{ 'GLOBAL.PLEASE_WAIT' | translate }}
      </div>
    </div>
  </kt-portlet-body>
  <kt-portlet-footer>
    <div class="mat-table__bottom">
      <mat-paginator
        [pageSize]="10"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="dataSource?.paginatorTotal$ | async"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </kt-portlet-footer>
</kt-portlet>
